package com.trevorwiebe.timesheet.core.domain.dto

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

/**
 * Partial payload for an admin reviewing a time-off request. Written with merge so it only
 * touches [approved] and [reviewedDate] on the existing request document.
 */
@Serializable
data class TimeOffReviewDto(
    val approved: Boolean,
    val reviewedDate: LocalDate,
)
